(() => {
  const start=()=>{
    document.documentElement.classList.remove('no-js');
    document.addEventListener('click', event => {
      const menuButton = document.querySelector('[data-menu-toggle]');
      const menu = document.querySelector('[data-mobile-menu]');
      if (event.target.closest('[data-menu-toggle]')) {
        const open = menuButton.getAttribute('aria-expanded') === 'true';
        menuButton.setAttribute('aria-expanded', String(!open));
        if (menu) menu.hidden = open;
      } else if (event.target.closest('[data-mobile-menu] a')) {
        if (menu) menu.hidden = true;
        menuButton?.setAttribute('aria-expanded', 'false');
      }
    });
    const overlay=document.getElementById('hugos-survey');if(!overlay)return;
    let opener=null;
    const inertNodes=[...document.body.children].filter(el=>el!==overlay&&el.tagName!=='SCRIPT'&&el.tagName!=='STYLE');
    function open(link){
      opener=link||document.activeElement;overlay.hidden=false;overlay.setAttribute('aria-hidden','false');overlay.classList.add('is-open');document.body.classList.add('survey-open');
      inertNodes.forEach(el=>{el.dataset.wasInert=String(el.inert);el.inert=true;});
      document.dispatchEvent(new CustomEvent('hugos:open'));const meat=link?.dataset.startMeat;if(meat)document.dispatchEvent(new CustomEvent('carls:filter',{detail:{meat,flavour:link?.dataset.startFlavour}}));
      overlay.querySelector('#cb-title')?.focus({preventScroll:true});
      if(meat){const card=[...overlay.querySelectorAll('.cb-card')].find(card=>card.dataset.id===link?.dataset.startFlavour);(card||overlay.querySelector('.cb-flavour-head'))?.scrollIntoView({behavior:'auto',block:'start'});}
      window.hugosTrack?.('hugos_builder_open');
      if(link?.dataset.startGoal)document.dispatchEvent(new CustomEvent('hugos:goal',{detail:{pouches:Number(link.dataset.startGoal)}}));
      if(link?.dataset.editBox)document.dispatchEvent(new CustomEvent('hugos:edit-cart',{detail:{key:link.dataset.editBox}}));
      document.dispatchEvent(new CustomEvent('carls:funnel-open',{detail:{directMeat:Boolean(meat||link?.dataset.startGoal||link?.dataset.editBox),flavour:link?.dataset.startFlavour,source:link?.dataset.source||'navigation'}}));
    }
    function close(){overlay.classList.remove('is-open');overlay.hidden=true;overlay.setAttribute('aria-hidden','true');document.body.classList.remove('survey-open');inertNodes.forEach(el=>{el.inert=el.dataset.wasInert==='true';delete el.dataset.wasInert;});if(location.hash==='#hugos-survey')history.replaceState(null,'',location.pathname+location.search);document.querySelector('[data-builder]')?.classList.remove('summary-open');overlay.querySelector('[data-review]')?.setAttribute('aria-expanded','false');opener?.focus?.();}
    document.addEventListener('click',event=>{
      const closeButton=event.target.closest('[data-survey-close]');if(closeButton){event.preventDefault();close();return;}
      const link=event.target.closest('a');if(!link)return;
      const href=link.getAttribute('href');if(href==='#hugos-survey'||href==='/pages/box-builder'||href==='/pages/build-your-box'||href==='/pages/quiz'){event.preventDefault();open(link);}
    });
    document.addEventListener('keydown',event=>{
      if(overlay.hidden)return;
      if(event.key==='Escape'){event.preventDefault();close();}
      if(event.key==='Tab'){
        const elements=[...overlay.querySelectorAll('a[href],button:not([disabled]),summary,input,select,[tabindex="0"]')].filter(el=>el.getClientRects().length&&!el.closest('[hidden]'));
        const first=elements[0],last=elements.at(-1);
        if(event.shiftKey&&(document.activeElement===first||document.activeElement.id==='cb-title')){event.preventDefault();last?.focus();}
        else if(!event.shiftKey&&document.activeElement===last){event.preventDefault();first?.focus();}
      }
    });
    if(location.hash==='#hugos-survey')open(null);
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start);else start();
})();
